import React from 'react'
import { compose } from 'ramda'
import marked from 'marked'
import ReactHtmlParser from 'react-html-parser'

import bills from '../../images/bills.svg'
import lightning from '../../images/lightning.svg'
import shop from '../../images/shop.svg'
import fees from '../../images/fees.svg'
import smile from '../../images/smile.svg'
import cash from '../../images/cash.svg'
import thumb from '../../images/thumb.svg'
// import blueCheck from '../../images/check_blue.svg'
// import orangeCheck from '../../images/check_orange.svg'

import styles from './icon-callouts.module.scss'

const iconMap = { bills, lightning, shop, fees, smile, cash, thumb }

const fromMarkup = compose(
  ReactHtmlParser,
  marked
)

export default function IconCallouts({ callouts }) {
  return (
    <section className={styles.iconCallouts}>
      {callouts.map(({ title, icon, description: { description } }) => (
        <div key={icon} className={styles.iconCallout}>
          <img
            alt={icon}
            className={styles.iconCalloutIcon}
            src={iconMap[icon]}
          />
          <h2>{title}</h2>
          {fromMarkup(description)}
        </div>
      ))}
    </section>
  )
}
